// @flow
import * as React from 'react'
import './styles.scss'

export default class Preloader extends React.Component<Props, State> {
    
    render() {
        return (
            <div className='app-preloader'>
                   
            </div>
        )
    }
}